/**
 * /api is appened since we have the same base path in server
 * @type {string}
 */
import { getApiServerBaseURL } from './getBaseURL';

const SERVER_BASE_URL = getApiServerBaseURL();
const BASE_URL = `${SERVER_BASE_URL}/api`;

const API_ENDPOINTS = {
  UPLOAD_URL: '/upload/file',
  UPLOAD_SUBMIT_URL: '/upload/uploadComplete',

  GET_ALL_USERS: '/admin/user/listing',
  GET_USER_URL: '/admin/user/detail/:uuid',
  UPDATE_USER_STATUS_URL: '/admin/user/statusChange',
  UPDATE_DEVICE_STATUS_URL: '/admin/device/statusChange',
  CREATE_NEW_USER_URL: '/admin/user/new',
  UPDATE_PROFILE_URL: 'user/update',
  UPDATE_USER_URL: 'admin/user/update/:uuid',
  DELETE_USER: '/admin/user/:uuid',
  DELETE_DEVICE_URL: '/admin/device/:uuid',
  CHANGE_SUPERVISOR_URL: '/admin/user/changeSupervisor',
  SEARCH_USER_FOR_KEY_URL: '/user/getList/:key',
  RESET_TELEGRAM_DETAILS: 'user/resetTelegram/:userKey',
  CHANGE_LANGUGAE_DETAILS: 'user/changeLanguage',
  SET_SEND_SMS_STATUS_URL: 'user/setSMS',
  UPDATE_USER_LABEL_DEFINITION_URL: 'user/setDeviceLabels',
  CHANGE_PASSWORD_ADMIN_URL: 'admin/changePasswordByAdmin',

  LOGIN_API_URL: '/auth/login',
  VALIDATE_TOKEN_API_URL: '/auth/validateToken',
  REGISTER_API_URL: '/auth/register',
  RESET_PASSWORD_URL: '/auth/changePassword',
  GET_ROLES_URL: '/auth/role/listing',
  SEND_RECOVERY_EMAIL: '/auth/sendRecoveryEmail',
  RESET_PASSWORD_FROM_TOKEN_URL: '/auth/changePasswordFromLink',

  GET_ALL_DEVICES_URL: '/devices/all',
  GET_ALL_DEVICES_FOR_USER_URL: '/devices/owned',
  ADD_NEW_DEVICE_URL: '/devices/new',
  CLONE_DEVICE_URL: '/devices/clone',
  GET_DEVICE_DETAILS_URL: '/devices/detail/:uuid',
  UPDATE_DEVICE_DETAILS_URL: '/devices/update/:uuid',
  CHANGE_OWNER_URL: '/devices/changeOwner',
  DELETE_OWNER_URL: '/devices/deleteOwner',
  GET_OWNED_DEVICES_BY_UUID_URL: '/devices/owned/:uuid',
  TRIGGER_CONFIG_UPDATE_URL: '/devices/configure',
  TRIGGER_SET_FALL_SWITCH_URL: '/devices/setFallSwitchAndSensitivity',
  SEARCH_DEVICE_FOR_KEY_URL: '/devices/getList/:key',
  CHECK_DEVICE_VALID_FOR_ONBOARDING: '/devices/onboard/valid/:deviceId',
  DEVICE_ONBOARD_FORM_SUBMIT: '/devices/onboard/submit',
  DEVICE_ONBOARD_SEND_EMAIL: '/devices/onboard/sendEmail',
  SET_PANIC_MODE_URL: "/devices/panicMode",
  RESET_DEVICE_URL: '/devices/resetAll/:uuid',
  UPDATE_DEVICE_LABEL_URL: '/devices/attachLabel',
  AUTOCOMPLETE_API: '/devices/address/autocomplete',
  AUTOCOMPLETE_PLACES_DETAILS_API: '/devices/address/place-details',

  GET_ALL_COMPANIES_URL: '/company/all',
  GET_COMPANY_DETAIL_URL: '/company/details/:uuid',
  CREATE_COMPANY_URL: '/company/new',
  UPDATE_COMPANY_DETAILS_URL: '/company/update/:uuid',
  DELETE_COMPANY_DETAILS_URL: '/company/delete/:uuid',
  COMPANY_STATUS_CHANGE_URL: '/company/statusChange',

  GET_ALL_BRANCHES_URL: '/branch/all',
  GET_BRANCH_DETAIL_URL: '/branch/details/:uuid',
  CREATE_BRANCH_URL: '/branch/new',
  UPDATE_BRANCH_DETAILS_URL: '/branch/update/:uuid',
  DELETE_BRANCH_DETAILS_URL: '/branch/delete/:uuid',
  BRANCH_STATUS_CHANGE_URL: '/branch/statusChange',

  ADD_RELATIVE_TO_DEVICE_URL: '/relation/new',
  DELETE_RELATIVE_FROM_DEVICE_URL: '/relation/delete',

  GET_ALL_DEVICE_MODELS_URL: '/models/all',

  GET_ALL_NOTIFICATIONS_URL: '/notification/all/after/:timeInMillis',
  MARK_ALL_NOTIFICATION_ACK_URL: '/notification/acknowledge',
  DELETE_ALL_NOTIFICATION_URL: '/notification/markDeleted',

  GET_ALL_READINGS_FOR_DEVICE: '/readings/:deviceIMEI/since/:timeInMillis',
  GET_OVERVIEW_DATA_URL: '/readings/overview/:deviceIMEI',
  GET_ALL_HR_READINGS_SINCE_URL: '/readings/:deviceIMEI/heartRate/:time',
  GET_ALL_STEPS_SINCE_URL: '/readings/:deviceIMEI/steps/:time',
  GET_ALL_SLEEP_DATA_SINCE_URL: '/readings/:deviceIMEI/sleep/:time',
  GET_ALL_BP_READINGS_SINCE_URL: '/readings/:deviceIMEI/bp/:time',
  GET_ALL_SPO2_READINGS_SINCE_URL: '/readings/:deviceIMEI/spo2/:time',
  GET_ALL_LOCATION_READINGS_SINCE_URL: '/readings/:deviceIMEI/location/:time',
  ADD_BOOKMARK_URL: '/readings/addBookmark',
  LIVE_LOCATION_URL: '/readings/liveLocation',

  CREATE_NEW_TASK_URL: '/tasks/new',
  UPDATE_TASK_URL: '/tasks/update/:uuid',
  FETCH_ALL_TASKS_FOR_CURRENT_USER_URL: '/tasks/all/:time',
  DELETE_TASK_URL: '/tasks/delete/:uuid',
  FETCH_TASK_DETAILS_URL: '/tasks/details/:uuid',
  FETCH_ALL_TASKS_BY_DEVICE_ID_URL: '/tasks/detailsByDeviceId/:deviceId',
  FETCH_ALL_TASKS_BY_USER_ID_URL: '/tasks/detailsByUserId/:userId',

  GET_ALL_BLT_ENTITIES_URL: '/blt/entity/all',
  SET_BLT_ENTITY_CONFIG_URL: '/blt/entity/configure',
  SEND_CONFIG_TO_BLT_ENTITY_CONFIG_URL: '/blt/entity/sendConfigToGateway',
  GET_ALL_BEACON_INTERACTIONS_URL: '/blt/interaction/:dmac/all/:since',
  GET_ALL_INTERACTIONS_URL: '/blt/interaction/all/:since',
  MARK_ALERTS_DONE_URL: '/blt/interaction/markAlertsDone',
  GET_ALERT_LOGS_URL: '/blt/interaction/:since/roomCheckLogs',
  GET_ROOMS_DATA: '/blt/interaction/getRoomsData',
  GET_BLT_ENTITY_BY_MAC_URL: '/blt/entity/detail/:macAddress',
  CREATE_BLT_GATEWAY_URL: '/blt/entity/gateway/new',
  CREATE_BLT_BEACON_URL: '/blt/entity/beacon/new',
  UPDATE_BLT_ENTITY_URL: '/blt/entity/update/:uuid',
  DELETE_BLT_ENTITY_URL: '/blt/entity/:uuid',

  NOTIFICATION_SOUND_URL: 'sounds/notification.mp3',
  ALARM_SOUND_URL: 'sounds/alarm.mp3',
};

export { BASE_URL, API_ENDPOINTS, SERVER_BASE_URL };
